module.exports = __webpack_public_path__ + "img/icon-draggable.ba15be67.svg";